'use strict';

angular.module('userRequestProcessControllers')

.controller('CardITPurchasingInstructionsController', ['$scope', function ($scope) {
}]);